module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAG1BMVEUAAAAWrDoWrDoWrDoWrDoWrDoWrDoWrDoWrDrCpT87AAAACHRSTlMA+VJIXerl3Sm9vBYAAABkSURBVCjPYxhWQC0YU4xFoh1T0LGjHYvCDmEsChsNqKFQtRiLwohGBUwTIzqEME1U7GhUwLCaSQKsFKEQoRShEKEUphBVKUQhmlKIQjSlYIXoSsEK0ZWCFGIoBSrEjK9khmECABBQIJGYQTE8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/poll_check.png
// module id = 755
// module chunks = 4